<template>
  <div class="detail" v-loading="fullscreenLoading">
    <!-- 分类 -->
    <div class="left-menus">
      <div class="operation">
        <el-button icon="el-icon-plus" size="mini" :disabled="!detail.id" @click="addClassify">添加一级分类</el-button>
      </div>
      <el-menu :default-active="menuIndex" @select="selectMenu">
        <el-menu-item index="0" v-if="detail.cover">
          <span slot="title" class="m-title">封面</span>
        </el-menu-item>
        <el-menu-item index="-1" v-if="detail.change">
          <span slot="title" class="m-title">更改记录</span>
        </el-menu-item>
        <el-menu-item index="-3" v-if="detail.catalogue">
          <span slot="title" class="m-title">目录</span>
        </el-menu-item>
        <el-menu-item index="-2" v-if="detail.explain">
          <span slot="title" class="m-title">其他说明</span>
        </el-menu-item>
        <el-submenu v-for="(item, index) in classifyList" :key="index" :index="`${item.id}`">
          <template slot="title">
            <div style="line-height: 26px;">
              <span class="m-title">{{ numberToChinese(index + 1) + '、' + item.name }}</span>
              <div style="display: flex; align-items: center;">
                <div class="t-btn" @click.stop="addClassify(item)">添加子类</div>
                <div class="t-btn" @click.stop="editClassify(item)">编辑</div>
                <div class="t-btn" @click.stop="delClassify(item)">删除</div>
              </div>
            </div>
          </template>
          <template v-if="item.classifies && item.classifies.length > 0">
            <el-menu-item v-for="(child, idx) in item.classifies" :key="idx" :index="`${child.id}`">
              <template slot="title">
                <div style="line-height: 26px;">
                  <span>{{ (index + 1) + '.' + (idx + 1) + ' ' + child.name }}</span>
                  <div style="display: flex; align-items: center;">
                    <div class="t-btn" @click.stop="editClassify(child)">编辑</div>
                    <div class="t-btn" @click.stop="delClassify(child)">删除</div>
                  </div>
                </div>
              </template>
            </el-menu-item>
          </template>
        </el-submenu>
      </el-menu>
    </div>
    <!-- 具体内容 -->
    <div class="right-content" @contextmenu.prevent @dragstart.prevent>
      <div v-if="showImgs && showImgs.length > 0" class="imgs">
        <el-image class="img" v-for="(img, index) in showImgs" :key="img" :src="img" fit="cover"></el-image>
      </div>
      <div v-else class="empty">
        <i class="icon el-icon-receiving"></i>
        <span class="tip">{{ !detail.id ? '报价书不存在' : '暂无内容' }}</span>
      </div>
    </div>

    <el-dialog :title="editTitle" :visible.sync="editVisible" width="500px" destroy-on-close lock-scroll append-to-body
      :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right" label-width="90px"
        size="small">
        <el-form-item v-if="editForm.classifyId" label="上级分类" prop="classifyId">
          <el-select v-model="editForm.classifyId" :disabled="!!editForm.id">
            <el-option v-for="item in classifyList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="editForm.name" maxlength="20" placeholder="请输入分类名称" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="分类排序" prop="sort">
          <el-input-number style="width: 200px;" v-model="editForm.sort" :min="1" controls-position="right"
            placeholder="请输入分类排序">
          </el-input-number>
          <div style="color: #919395; font-size: 12px;">
            <i class="el-icon-info" style="margin-right: 5px;" />页面上显示顺序根据该数字由小到大升序排序
          </div>
        </el-form-item>
        <el-form-item v-if="editForm.classifyId" label="分类图片" prop="imgs">
          <MultiImg v-if="editVisible" key="imgs" v-model="editForm.imgs" :limit="99"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="submit('editForm')">立即提交</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    getOfferBookDetail,
    addOrEditOfferClassify,
    delOfferClassify
  } from '@/api/quotation'

  import MultiImg from './components/MultiImg'

  export default {
    name: 'quotation-edit',
    components: {
      MultiImg
    },
    data() {
      return {
        tempRoute: {},

        menuIndex: '0',
        menuPath: [],
        menuItem: {},

        fullscreenLoading: false,
        loading: false,
        detail: {},
        classifyList: [],

        id: '',
        editTitle: '添加分类',
        editVisible: false,
        editForm: {
          id: '',
          name: '',
        },
        editRules: {
          name: [{
            required: true,
            message: '请输入分类名称',
            trigger: 'blur'
          }],
          classifyId: [{
            required: true,
            message: '请选择上级分类',
            trigger: 'change'
          }],
          sort: [{
            required: true,
            message: '请输入分类排序',
            trigger: 'blur'
          }],
          imgs: [{
            required: true,
            message: '请上传子分类图片',
            trigger: 'change'
          }],
        },
        editloading: false
      }
    },
    computed: {
      user: getUser,
      showImgs() {
        let imgs = [];
        if (this.menuIndex == '0') {
          imgs = this.detail.cover ? this.detail.cover.split(',') : [];
        } else if (this.menuIndex == '-1') {
          imgs = this.detail.change ? this.detail.change.split(',') : [];
        } else if (this.menuIndex == '-2') {
          imgs = this.detail.explain ? this.detail.explain.split(',') : [];
        } else if (this.menuIndex == '-3') {
          imgs = this.detail.catalogue ? this.detail.catalogue.split(',') : [];
        } else {
          imgs = this.menuItem.imgs ? this.menuItem.imgs.split(',') : [];
        }
        return imgs;
      }
    },
    created() {
      this.tempRoute = Object.assign({}, this.$route)
      this.id = this.$route.params && this.$route.params.id
      if (!this.id) {
        this.$message({
          message: '报价书ID不存在',
          type: 'error'
        })
        return;
      }
      this.getData()
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      })
    },
    methods: {
      selectMenu(index, path) {
        this.menuIndex = index;
        this.menuPath = path;
        if (this.menuPath && this.menuPath.length == 2) {
          this.menuItem = this.classifyList.filter(r => r.id == this.menuPath[0])[0].classifies.filter(r => r.id == this.menuPath[1])[0];
        }
      },

      deafultMenuIndex() {
        if (this.detail && this.detail.id) {
          if (this.detail.cover) return '0';
          if (this.detail.cover) return '1';
          if (this.detail.explain) return '-2';
          if (this.detail.catalogue) return '-3';
          if (this.classifyList && this.classifyList.length > 0) {
            const item = this.classifyList[0];
            if (item && item.classifies && item.classifies.length > 0) {
              return `${item.classifies[0].id}`;
            }
          }
        }
        return '0';
      },

      numberToChinese(num) {
        const arr = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十");
        let result = num + '';
        if (num <= 10) {
          result = arr[num];
        }
        return result;
      },

      getData() {
        this.loading = true
        getOfferBookDetail({
          userId: this.user.dUserid,
          groupId: this.user.dGroupid,
          id: this.id
        }).then(response => {
          // console.log(response)
          this.loading = false
          this.detail = response.data || {}
          this.classifyList = this.detail.classifies || []

          if (this.menuIndex == '0') {
            this.menuIndex = this.deafultMenuIndex()
          } else {
            this.selectMenu(this.menuIndex, this.menuPath)
          }

          const pageTitle = `上传报价书${this.detail.name ? '-' + this.detail.name : ''}`
          document.title = pageTitle
          const route = Object.assign({}, this.tempRoute, {
            title: pageTitle
          })
          this.$store.dispatch('tagsView/updateVisitedView', route)
        }).catch(() => {
          this.loading = false
        })
      },

      addClassify(item = {}) {
        this.editTitle = item && item.id ? '添加子分类' : '添加一级分类'
        this.editVisible = true

        this.editForm = {
          classifyId: item.id,
          sort: 1
        }
      },
      editClassify(item = {}) {
        this.editTitle = '编辑分类'
        this.editVisible = true
        this.editForm = {
          id: item.id,
          name: item.name,
          classifyId: item.classifyId,
          sort: item.sort || 1,
          imgs: item.imgs ? item.imgs.split(',') : []
        }
      },
      delClassify(item = {}) {
        if (!item.id) return;
        this.$confirm('删除分类 《' + item.name + '》，删除后无法恢复, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = true
          delOfferClassify({
            id: item.id
          }).then(response => {
            this.fullscreenLoading = false
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            if (this.menuIndex == item.id) {
              this.menuIndex = this.deafultMenuIndex()
            }
            this.getData()
          }).catch(() => {
            this.fullscreenLoading = false
          })
        }).catch(() => {})
      },

      cancel() {
        this.editVisible = false
      },

      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.editloading) return;
            this.editloading = true
            const data = {
              userId: this.user.dUserid,
              groupId: this.user.dGroupid,
              bookId: this.detail.id,
              id: this.editForm.id,
              classifyId: this.editForm.classifyId,
              name: this.editForm.name,
              sort: this.editForm.sort,
              imgs: Array.isArray(this.editForm.imgs) ? this.editForm.imgs.join(',') : (this.editForm.imgs || '')
            }
            // console.log(data)
            addOrEditOfferClassify(data).then(response => {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.editVisible = false
              this.editloading = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            });
          }
        });
      },

    }
  }
</script>

<style lang="scss" scoped>
  .detail {
    position: relative;
    height: calc(100vh - 84px);
    display: flex;
  }

  .left-menus {
    width: 240px;
    min-width: 240px;
    height: 100%;
    background: #ffffff;
    border: 1px solid #e6e6e6;
    overflow-y: auto;

    .m-title {
      font-weight: bold;
    }

    .operation {
      padding: 10px 20px;
      border-bottom: 2px solid #e6e6e6;
    }

    .t-btn {
      margin-top: 4px;
      margin-left: 10px;
      font-size: 11px;
      color: #409EFF;
      line-height: 1;

      &:hover {
        color: #409EFFAA;
      }
    }

    .t-btn:first-child {
      margin-left: 0;
    }
  }

  .right-content {
    flex: 1;
    height: 100%;
    overflow-y: auto;
  }

  .imgs {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;

    .img {
      flex: 1;
      height: auto;
      user-select: none;
    }
  }

  .empty {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .icon {
      font-size: 100px;
      color: #dcdfe6;
    }

    .tip {
      padding: 15px 0;
      font-size: 14px;
      color: #909399;
    }
  }
</style>
